




















































import {Vue, Component, Prop, Watch} from 'vue-property-decorator';
import {nil, UPLOAD_PURPOSES} from '@/common';
import CreateOrEditDialog from '@/components/Views/UI/CreateOrEditDialog.vue';
import {Mixins} from 'vue-property-decorator';
import {FeathersVuexFindAll} from '@/utils';
import CurrencyMixin from '@/mixins/CurrencyMixin.vue';
import ImportDialog from '@/components/Views/Dashboard/Import & Export/ImportDialog.vue';
import ImageGrid from '@/components/Views/UI/ImageGrid.vue';
import SelectImportedFilesDialog from '@/components/Views/Dashboard/Import & Export/SelectImportedFilesDialog.vue';
import ImageGrid2 from '@/components/Views/UI/ImageGrid2.vue';
import {pickBy} from 'lodash';

@Component({
    components: {
        ImageGrid2,
        SelectImportedFilesDialog,
        ImageGrid,
        ImportDialog,
        CreateOrEditDialog,
    },
})
export default class ServiceDialog extends Mixins(CurrencyMixin) {
    public makeItem = () => ({
        category: 'Weddings',
        tier: 'Plush',
        description: '',
        displayName: '',
        displayNameSubtitle: '',
        name: '',
        hourlyLimit: 2,
        price: 0,
        vendorCut: 0,
        serviceTypes: [],
        images: [],
    });

    public service = null;
    @Watch('service')
    public onServiceChanged(value: any, oldValue: any) {
        this.refreshService();
    }
    public purposeForServiceImages = UPLOAD_PURPOSES.IMAGE_SERVICE;
    public dialogHeight = 0;
    public editedItem = this.makeItem();
    public defaultItem = this.makeItem();
    public categories = [];
    public tiers = [];
    public serviceTypes: any[] = [];
    public openWith(service) {
        if (!nil(service)) { this.service = service; }
        (this.$refs.dialog as any).open = true;
        setTimeout(() => {
            this.dialogHeight = document.querySelector('.service-form-left-side').clientHeight;
        }, 1000);
    }
    public close() {
        (this.$refs.dialog as any).open = false;
    }
    public mounted() {
        this.initialize();
        this.refreshService();
    }
    public async initialize() {
        this.categories = await FeathersVuexFindAll(this.$FeathersVuex.Category, {});
        this.tiers = await FeathersVuexFindAll(this.$FeathersVuex.Tier, {});
        this.serviceTypes = await FeathersVuexFindAll(this.$FeathersVuex.ServiceType, {});
    }
    public refreshService() {
        this.editedItem = Object.assign({}, this.defaultItem);
        if (nil(this.service)) {
            return;
        }
        this.editedItem = Object.assign({}, this.service);
        (this.$refs.tierSelect as any).selectItem(this.editedItem.tier);
        (this.$refs.categorySelect as any).selectItem(this.editedItem.category);
    }
    public imagesAdded(data) {
        // this.refreshService();
        this.service.imageModels.push(data);
        this.service.images.push(data._id);
    }
    public get hasImages() {
        return !nil(this.service) && !nil(Object(this.asSelectionMap), true);
    }
    public onClose() {
        (this.$refs.dialog as any).open = false;
    }

    public async onSubmit() {
        let isSave = true;
        if (nil(this.service)) {
            this.service = Object.assign({}, this.editedItem);
            isSave = false;
        }
        this.service.category = this.editedItem.category;
        this.service.tier = this.editedItem.tier;
        this.service.description = this.editedItem.description;
        this.service.name = this.editedItem.name;
        this.service.price = this.editedItem.price;
        this.service.vendorCut = this.editedItem.vendorCut;
        this.service.displayName = this.editedItem.displayName;
        this.service.displayNameSubtitle = this.editedItem.displayNameSubtitle;
        this.service.hourlyLimit = this.editedItem.hourlyLimit;
        this.service.serviceTypes = this.editedItem.serviceTypes || [];
        if (isSave) {
            await this.service.save();
        } else {
            const s = new this.$FeathersVuex.Purchasable(this.service);
            await s.save();
        }

        (this.$refs.dialog as any).open = false;
    }
    public get asSelectionMap() {
        const obj = {};
        if (nil(this.service) || nil(this.service.images, true)) { return obj; }
        for (const image of this.service.images) {
            obj[image] = true;
        }
        return obj;
    }
    public set asSelectionMap(value) {
        this.service.images = Object.keys(pickBy(value, (x) => x));
    }
}
